function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.002 13C4.705 13 0 9.232 0 5.129 0 2.296 2.24 0 5.002 0c2.762 0 5.001 2.296 5.001 5.129 0 4.103-4.705 7.87-5.001 7.87zM5 7a2 2 0 100-4 2 2 0 000 4z"
});

function SvgAddressIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 13",
    width: 10,
    height: 13
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 13' width='10' height='13' %3E %3Cpath d='M5.0016685 12.9998169C4.7051828 12.9998169 0 9.2315462 0 5.1286368 0 2.29616891 2.23932328 0 5.0016685 0c2.7623453 0 5.0016692 2.29617531 5.0016686 5.1286368-.000001 4.1029094-4.705183 7.8711801-5.0016686 7.8711801zM5 7c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2z' /%3E %3C/svg%3E";
export { SvgAddressIcon as ReactComponent };